import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoQuickviewFilter} from "./models/DtoQuickviewFilter";
import {DtoQuickview} from "./models/DtoQuickview";

@Injectable()
export class ManagementQuickviewService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'management'
    }

    public getQuickview = (filter: DtoQuickviewFilter): Observable<DtoQuickview> => {
        return this.http.post<DtoQuickview>(`${this.apiUrl}/quickview/`, filter);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/quickview/management-quickview.service.ts